import { memo } from "react";
import { useNavigate } from "react-router-dom";

import { backdropClasses, Box } from "@mui/material";
import SvgIconStyle from "./SvgIconStyle";
import LogoIcon from "assets/icons/logo.svg";

// ----------------------------------------------------------------------

function Logo({ onDark = false, isSimple = false, sx }) {
	const navigate = useNavigate();

	return (
	
			<SvgIconStyle
				src={LogoIcon}
				origin
				sx={{ width: 120, ...sx, }}
			/>
	);
}

export default memo(Logo);
